/* ==========================================================================
   Karchir — yumuşak kaydırma

   Pebble'da sayfa tekerlek hareketiyle ZIPLAMIYOR; hedefe doğru yumuşayarak
   iniyor. Ölçüm (analiz/pebble-kaydirma.js, 1440px): 400px'lik tek bir
   tekerlek hareketi ~600ms'de oturuyor, eğri üstel (her karede kalan
   mesafenin sabit bir oranı kapanıyor). Pebble bunu Lenis ile yapıyor;
   biz aynı davranışı kendi kodumuzla yazdık — kütüphane eklenmedi.

   SINIRLAR (bilerek):
     - yalnız FARE TEKERLEĞİ yumuşatılıyor. Dokunmatik kaydırma, klavye ve
       kaydırma çubuğu tarayıcının kendi davranışında bırakıldı; oraya
       karışmak hem riskli hem gereksiz.
     - "hareketi azalt" tercihi açıksa hiç devreye girmiyor.
     - içinde kendi kaydırma alanı olan bir kutunun üstündeyken (sepet
       çekmecesi, hızlı bakış panelinin görsel şeridi, açık pencereler)
       dokunulmuyor.
   ========================================================================== */

(() => {
  'use strict';

  const AZALT = window.matchMedia('(prefers-reduced-motion: reduce)');
  const INCE_IMLEC = window.matchMedia('(pointer: fine)');

  /* Her karede kalan mesafenin bu oranı kapanıyor. Pebble'ın ölçülen
     eğrisine en yakın değer 0.12 çıktı (400px -> ~600ms). */
  const ORAN = 0.12;

  /** Horizon 990px ve üstünde sayfayı .page-wrapper ile kaydırıyor (base.css).
      Tur 142: her teker olayında scrollHeight okuyup düzen hesaplatmamak için
      kaydırıcı genişliğe göre seçiliyor. */
  const MASAUSTU_KAYDIRICI = window.matchMedia('(min-width: 990px)');
  function anaKaydirici() {
    const w = MASAUSTU_KAYDIRICI.matches ? document.querySelector('.page-wrapper') : null;
    return w || document.scrollingElement || document.documentElement;
  }

  /** Olayın altında, ana kaydırıcıya varmadan önce kendi kaydırma alanı
      olan bir kutu var mı? Varsa ona karışmıyoruz. */
  /* Tur 142: aynı hareketin (trackpad saniyede ~60 olay) her olayında ataları
     getComputedStyle ile yeniden taramayalım: 250 ms içinde aynı hedefse sonuç aynı */
  let sonIcHedef = null;
  let sonIcSonuc = false;
  let sonIcZaman = 0;
  function icKaydiriciVar(hedef, ana) {
    const simdi = performance.now();
    if (hedef === sonIcHedef && simdi - sonIcZaman < 250) return sonIcSonuc;
    sonIcHedef = hedef;
    sonIcZaman = simdi;
    sonIcSonuc = icKaydiriciTara(hedef, ana);
    return sonIcSonuc;
  }
  function icKaydiriciTara(hedef, ana) {
    let e = hedef;
    while (e && e !== ana && e !== document.body && e !== document.documentElement) {
      if (e.nodeType === 1) {
        const s = getComputedStyle(e);
        const kayar = /(auto|scroll|overlay)/.test(s.overflowY);
        if (kayar && e.scrollHeight > e.clientHeight + 4) return true;
      }
      e = e.parentElement;
    }
    return false;
  }

  let el = null;
  let hedef = 0;
  let calisiyor = false;
  let eskiDavranis = '';
  /* Son karede BİZİM yazdığımız konum. Bir sonraki karede kaydırıcı başka
     bir yerdeyse (bağlantı çapası, scrollIntoView, başka bir betik) sayfayı
     geri çekmeyip animasyonu bırakıyoruz — aksi hâlde dışarıdan yapılan
     her kaydırma bizimle yarışıyor. */
  let sonKonum = 0;

  /* ÖNEMLİ: kaydırıcıda "scroll-behavior: smooth" tanımlı. O açıkken her
     scrollTop ataması AYRICA animasyona giriyor ve bizim kare döngümüzle
     yarışıyor — ilk ölçümde sayfa 400px yerine sürüne sürüne 188px'e
     gidiyordu. Animasyon boyunca davranışı "auto"ya çekip sonra geri
     veriyoruz. */
  function davranisKapat() {
    if (!el) return;
    eskiDavranis = el.style.scrollBehavior;
    el.style.scrollBehavior = 'auto';
  }

  function davranisAc() {
    if (!el) return;
    el.style.scrollBehavior = eskiDavranis;
  }

  function adim() {
    if (!el) {
      calisiyor = false;
      return;
    }
    if (Math.abs(el.scrollTop - sonKonum) > 1) {
      // Dışarıdan kaydırılmış: bırak
      davranisAc();
      calisiyor = false;
      el = null;
      return;
    }
    const fark = hedef - el.scrollTop;
    if (Math.abs(fark) < 0.5) {
      el.scrollTop = hedef;
      davranisAc();
      calisiyor = false;
      el = null;
      return;
    }
    // Tur 142 (akıcılık): tarayıcı scrollTop'u tam piksele yuvarlıyor; 1px'ten
    // küçük adım yerinde sayıyor, döngü hiç bitmiyordu (sayfa hedefin 4px
    // gerisinde, saniyede 60 kare boşa). En az 1px ilerle; yine de
    // kıpırdamıyorsa (sayfa sonu vb.) bırak.
    const once = el.scrollTop;
    let adimPx = fark * ORAN;
    if (Math.abs(adimPx) < 1) adimPx = Math.sign(fark) * Math.min(1, Math.abs(fark));
    el.scrollTop = once + adimPx;
    sonKonum = el.scrollTop;
    if (sonKonum === once) {
      davranisAc();
      calisiyor = false;
      el = null;
      return;
    }
    requestAnimationFrame(adim);
  }

  function tekerlek(olay) {
    if (AZALT.matches || !INCE_IMLEC.matches) return;
    if (olay.ctrlKey || olay.metaKey) return; // yakınlaştırma
    if (olay.deltaY === 0) return;
    if (Math.abs(olay.deltaX) > Math.abs(olay.deltaY)) return; // yatay şerit
    if (document.querySelector('dialog[open]')) return; // çekmece/panel açık

    const ana = anaKaydirici();
    if (!ana) return;
    if (icKaydiriciVar(olay.target, ana)) return;

    const enFazla = ana.scrollHeight - ana.clientHeight;
    if (enFazla <= 0) return;

    // Yeni bir kaydırıcıya geçtiysek hedefi oradan başlat
    if (el !== ana || !calisiyor) hedef = ana.scrollTop;
    el = ana;

    // Satır/sayfa birimlerini piksele çevir
    let delta = olay.deltaY;
    if (olay.deltaMode === 1) delta *= 16;
    else if (olay.deltaMode === 2) delta *= ana.clientHeight;

    const yeni = Math.max(0, Math.min(enFazla, hedef + delta));
    // Uçlara dayandıysak tarayıcıya bırak (sayfa dışı kaydırma vb.)
    if (yeni === hedef) return;

    olay.preventDefault();
    hedef = yeni;
    if (!calisiyor) {
      calisiyor = true;
      sonKonum = ana.scrollTop;
      davranisKapat();
      requestAnimationFrame(adim);
    }
  }

  window.addEventListener('wheel', tekerlek, { passive: false });

  /* Bir bağlantı/ok bizi programla kaydırırsa (ör. ürün sayfasındaki küçük
     görsel rayı) kendi animasyonumuz onunla yarışmasın. */
  ['keydown', 'touchstart'].forEach((t) =>
    window.addEventListener(t, () => {
      davranisAc();
      calisiyor = false;
      el = null;
    }, { passive: true })
  );
})();

/* Tur 142 (erişilebilirlik): 990px ve üstünde sayfayı .page-wrapper
   kaydırıyor; sayfaya hiç tıklanmadan PageDown/Boşluk/ok tuşları bir şey
   yapmıyordu (odak body'de). İlk kaydırma tuşunda odağı page-wrapper'a
   veriyoruz; odak oradan çıkınca geçici tabindex kaldırılıyor. */
(() => {
  'use strict';
  const TUSLAR = ['PageDown', 'PageUp', 'ArrowDown', 'ArrowUp', ' ', 'Home', 'End'];
  const MASAUSTU = window.matchMedia('(min-width: 990px)');
  document.addEventListener(
    'keydown',
    (e) => {
      if (!MASAUSTU.matches || TUSLAR.indexOf(e.key) < 0) return;
      const a = document.activeElement;
      if (a && a !== document.body && a !== document.documentElement) return;
      const pw = document.querySelector('.page-wrapper');
      if (!pw) return;
      if (!pw.hasAttribute('tabindex')) pw.setAttribute('tabindex', '-1');
      pw.focus({ preventScroll: true });
      pw.addEventListener('blur', () => pw.removeAttribute('tabindex'), { once: true });
    },
    true
  );
})();
